import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { RouterModule } from '@angular/router';
import { MenuPopoverComponent } from './menu-popover.component';

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, RouterModule],
  declarations: [MenuPopoverComponent],
  exports: [MenuPopoverComponent]
})
export class MenuPopoverComponentModule { }
